import type { SVGProps } from 'react'

const PancakeSwap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 198 199"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M98.552 198.607C69.0613 198.585 45.306 191.58 28.7079 178.998C11.9108 166.265 3 148.195 3 127.748C3 108.047 11.8913 93.8411 21.9517 84.2385C29.8359 76.7132 38.5363 71.8936 44.5945 69.1213C43.2245 64.9594 41.5153 59.5108 39.9861 53.8832C37.9399 46.3527 35.9325 37.5174 35.9325 31.0429C35.9325 23.3795 37.6204 15.6833 42.1714 9.70306C46.9797 3.38476 54.2182 0 62.9264 0C69.7322 0 75.5103 2.49903 80.0339 6.81011C84.3579 10.9309 87.2357 16.4034 89.2227 22.1082C92.7143 32.1325 94.0738 44.7264 94.4551 57.2945H102.796C103.178 44.7264 104.537 32.1325 108.029 22.1082C110.016 16.4034 112.894 10.9309 117.218 6.81011C121.741 2.49903 127.519 0 134.325 0C143.033 0 150.272 3.38476 155.08 9.70306C159.631 15.6833 161.319 23.3795 161.319 31.0429C161.319 37.5174 159.312 46.3527 157.265 53.8832C155.736 59.5108 154.027 64.9594 152.657 69.1213C158.715 71.8936 167.416 76.7132 175.3 84.2385C185.36 93.8411 194.252 108.047 194.252 127.748C194.252 148.195 185.341 166.265 168.544 178.998C151.945 191.58 128.19 198.585 98.6996 198.607H98.552Z"
      fill="#633001"
    />
    <path
      d="M62.9262 7.28833C50.1716 7.28833 44.3004 16.8037 44.3004 29.9632C44.3004 40.4231 51.1222 61.3715 53.9212 69.5263C54.5508 71.3605 53.5616 73.3701 51.7574 74.0814C41.5351 78.1121 11.3679 92.87 11.3679 126.669C11.3679 162.272 42.0246 189.117 98.5581 189.16C98.5806 189.16 98.6031 189.159 98.6256 189.159C98.6481 189.159 98.6706 189.16 98.6931 189.16C155.227 189.117 185.883 162.272 185.883 126.669C185.883 92.87 155.716 78.1121 145.494 74.0814C143.69 73.3701 142.7 71.3605 143.33 69.5263C146.129 61.3715 152.951 40.4231 152.951 29.9632C152.951 16.8037 147.08 7.28833 134.325 7.28833C115.965 7.28833 111.389 33.2955 111.062 61.2075C111.04 63.0709 109.534 64.5828 107.67 64.5828H89.5807C87.7172 64.5828 86.2108 63.0709 86.189 61.2075C85.8626 33.2955 81.286 7.28833 62.9262 7.28833Z"
      fill="#D1884F"
    />
    <path
      d="M98.6931 177.755C57.1551 177.755 11.4397 155.52 11.3681 126.737C11.368 126.781 11.3679 126.826 11.3679 126.871C11.3679 162.503 42.0734 189.362 98.6931 189.362C155.313 189.362 186.018 162.503 186.018 126.871C186.018 126.826 186.018 126.781 186.018 126.737C185.946 155.52 140.231 177.755 98.6931 177.755Z"
      fill="#FEDC90"
    />
    <path
      d="M75.6135 117.896C75.6135 127.614 71.021 132.675 65.3558 132.675C59.6907 132.675 55.0981 127.614 55.0981 117.896C55.0981 108.178 59.6907 103.117 65.3558 103.117C71.021 103.117 75.6135 108.178 75.6135 117.896Z"
      fill="#633001"
    />
    <path
      d="M142.288 117.896C142.288 127.614 137.696 132.675 132.031 132.675C126.365 132.675 121.773 127.614 121.773 117.896C121.773 108.178 126.365 103.117 132.031 103.117C137.696 103.117 142.288 108.178 142.288 117.896Z"
      fill="#633001"
    />
  </svg>
)

export default PancakeSwap
